import { axiosInstance } from '../../config/axiosConfig';
import { AxiosError, AxiosResponse } from 'axios';
import { endPointUrls } from '../constants/endPoints';
import { IUserPreferences, IUserProfileResponse } from '../types/user.type';

const getUserProfile = (): Promise<IUserProfileResponse> => {
    return axiosInstance
        .get(endPointUrls.getUserProfile)
        .then((res: AxiosResponse<IUserProfileResponse>) => {
            return res.data;
        })
        .catch((error: AxiosError) => {
            throw error;
        });
};

const updateUserProfile = (reqBody: IUserPreferences): Promise<{ data: { message: string } }> => {
    return axiosInstance
        .patch(endPointUrls.updateUserProfile, reqBody)
        .then((res: AxiosResponse<{ data: { message: string } }>) => {
            return res.data;
        })
        .catch((error: AxiosError) => {
            throw error;
        });
};

const logout = async (): Promise<any> => {
    return axiosInstance
            .get(endPointUrls.logout)
            .then((res: AxiosResponse<any>) => {
                localStorage.clear();
                return res.data;
            })
            .catch((error: AxiosError) => {
                localStorage.clear();
                throw error;
            });
};

const invalidatePrallelSessions = async (): Promise<any> => {
    return axiosInstance
            .get(endPointUrls.invalidateParallelSessions)
            .then((res: AxiosResponse<any>) => {
                return res.data;
            })
            .catch((error: AxiosError) => {
                throw error;
            });
};

const userProfileService = {
    getUserProfile,
    updateUserProfile,
    logout,
    invalidatePrallelSessions,
};

export default userProfileService;
